var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    width: 64,
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.729,11h-0.85c-1.051,0-2.041,0.49-2.68,1.324l-8.7,11.377l-8.7-11.377C28.162,11.49,27.171,11,26.121,11h-0.85 l10.971,14.346L25.036,40h0.85c1.051,0,2.041-0.49,2.679-1.324L37.5,26.992l8.935,11.684C47.073,39.51,48.063,40,49.114,40h0.85 L38.758,25.346L49.729,11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.289,34.242c-2.554,3.881-7.582,5.87-12.389,4.116C4.671,36.815,2,32.611,2,28.109L2,27h12v0h11l0-4.134 c0-6.505-4.818-12.2-11.295-12.809C6.273,9.358,0,15.21,0,22.5l0,5.573c0,5.371,3.215,10.364,8.269,12.183 c6.603,2.376,13.548-1.17,15.896-7.256c0,0,0,0,0,0h-0.638C22.616,33,21.789,33.481,21.289,34.242z M2,22.5C2,16.71,6.71,12,12.5,12 S23,16.71,23,22.5V25H2V22.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpress);
export default __webpack_public_path__ + "static/media/express.0a04938f4766693f01d606287489baa2.svg";
export { ForwardRef as ReactComponent };